import React, { useEffect } from "react";
import _ from "lodash";
import WizardPageLayout from "component-lib/WizardPageLayout";
import LoadingIndicator from "components/LoadingIndicator";
import { connect } from "react-redux";
import { withRouter } from "react-router";
import { bindActionCreators, compose } from "redux";

import { dealGet } from "../../../deal/deal.store";
import LoansSelectionStep from "../loansSelectionStep";
import { actionCreators as reportDashboardActionCreators } from "../../dashboard/dashboard.store";

import { actionCreators as debtYieldSetupActionCreators } from "./debtYieldSetup.store";

const LenderReportsDebtYieldSetup = props => {
  const {
    deal,
    match: {
      params: { dealId, reportId }
    },
    allDealLoans,
    getAllLoansForDeal,
    setDebtYieldSetupSelections,
    reportProjectedComponentsForSelectedGroup,
    getProjectedReportComponentsForReportGroup,
    setDashboardSelections
  } = props;

  useEffect(()=>{
    setDashboardSelections({isProjected: true});
  },[]);

  useEffect(() => {
    if (_.isEmpty(deal)) {
      props.dealGet({ dealId });
    }
  }, [dealId, deal]);

  useEffect(() => {
    if (!reportProjectedComponentsForSelectedGroup) {
      getProjectedReportComponentsForReportGroup({ reportGroupId: reportId });
    }
  }, [reportId, reportProjectedComponentsForSelectedGroup]);

  useEffect(() => {
    if (!allDealLoans) {
      getAllLoansForDeal({ dealId });
    }
  }, [allDealLoans]);

  useEffect(() => {
    const debtYieldReportComponent = reportProjectedComponentsForSelectedGroup && reportProjectedComponentsForSelectedGroup.find(comp => comp.type === "DebtYield");
    if (debtYieldReportComponent && allDealLoans) {
      // set loans selected based on existing calculations
      const filteredLoans = allDealLoans.filter(loan => debtYieldReportComponent.calculations?.selectedLoans.find(l => l.id === loan.id));
      setDebtYieldSetupSelections({
        debtYieldCalculations: debtYieldReportComponent.calculations.selectedLoans,
        selectedLoansForDY: filteredLoans,
        debtYieldReportComponent,
        totalDebtYieldValue: debtYieldReportComponent.calculations.totalDebtYieldValue
      });
    }
  }, [reportProjectedComponentsForSelectedGroup, allDealLoans]);

  return <WizardPageLayout cardComponent={deal ? <LoansSelectionStep {...props} componentType="DyProjected" /> : <LoadingIndicator />} />;
};

const mapStateToProps = ({ newDeal: { deal }, authentication: { user }, lenderReportsDebtYieldSetup, lenderReportList }) => ({
  deal,
  user,
  ...lenderReportsDebtYieldSetup,
  ...lenderReportList
});
const mapDispatchToProps = dispatch => bindActionCreators({ dealGet, ...debtYieldSetupActionCreators, ...reportDashboardActionCreators }, dispatch);

export default compose(withRouter, connect(mapStateToProps, mapDispatchToProps))(LenderReportsDebtYieldSetup);
